import React from "react";
import styles from "./MapBanner.module.css";
import placeholder960x460 from "assets/placeholder/960x460.png";

const MapBanner = ({ bannerSrc, width= '100%' }) => {
  return (
    <div className={styles.banner}>
      {bannerSrc && <img src={bannerSrc} style={{width: width}} alt="banner" /> }
    </div>
  );
};

export default MapBanner;
